import React, { Component, Fragment } from 'react'

export default class extends Component {
  render() {
    const { children } = this.props
    return <Fragment>{children}</Fragment>
  }
}
